/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any) => ({
  // 제품 목록 조회
  async index(data?: any) {
    return camelize(
      await $axios.get(`/emergency/products`, snakelize({ params: data }))
    );
  },

  // 제품 조회
  async show(data?: any) {
    return camelize(
      await $axios.get(
        `/emergency/products/${data.id}`,
        snakelize({ params: data })
      )
    );
  },

  // 제품 수정
  async update(data?: any) {
    await camelize(
      $axios.patch(`/emergency/products${data.id}`, snakelize(data))
    );
  },

  // 제품 등록
  async store(data?: any) {
    return camelize(await $axios.post(`/emergency/products`, snakelize(data)));
  },

  // 제품 등록
  async hide(data?: any) {
    return camelize(
      await $axios.post(`/emergency/products${data.id}/hide`, snakelize(data))
    );
  },

  // 제품 제거
  async delete(data?: any) {
    return camelize(
      await $axios.delete(
        `/emergency/products${data.id}`,
        snakelize({ params: data })
      )
    );
  },
});
